import { staticFilterSetReducer as staticFilterSet } from '../../features/static-filter-set/static-filter-set-slice.js';
import { registerStaticFilter, toggleSelectStaticFilterValue, deselectAllStaticFilterValues, toggleExcludeStaticFilterValue, } from './static-filter-set-actions.js';
/**
 * Loads the `staticFilterSet` reducer and returns possible action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category StaticFilterSet
 */
export function loadStaticFilterSetActions(engine) {
    engine.addReducers({ staticFilterSet });
    return {
        registerStaticFilter,
        toggleSelectStaticFilterValue,
        toggleExcludeStaticFilterValue,
        deselectAllStaticFilterValues,
    };
}
